import {
    QueryPromoteInfoUsingGet1Params,
    PromoteInfoVo,
    QueryInviteSpuCountVo,
    SpuCountVo,
    InviteDisSpuCountVo
} from '@servicesTypings/goodsRequest'

import { EditQrCodeUrlVo } from '@servicesTypings/drpRequest'
import { companyRequest, openCompanyRequest, goodsRequest, openGoodsRequest, drpRequest } from '@/utils/request'
import { getCacheService } from '@/utils/requestUtils'

const getMpEnvVersion = () => {
    //  envVersion: 'trial',  默认是release
    const target = { envVersion: 'trial' }
    const isProd = PROJECT_CONFIG.mode === 'prod'
    const isPre = PROJECT_CONFIG.sentryMode === 'pre'
    if (isPre) {
        return target
    }
    return isProd ? {} : target
}

// 获取小程序码的 url
export function getWeChatCodeUrl(data) {
    const version = getMpEnvVersion()
    return companyRequest.post('/wechat/miniProgram/weChatCodeUrl', {
        data: {
            checkPath: false,
            ...version,
            ...data
        }
    })
}

// 获取小程序码的 url open
export function getWeChatCodeUrlOpen(data) {
    const openCompanyRequestCache = getCacheService(openCompanyRequest)
    const version = getMpEnvVersion()
    return openCompanyRequestCache.post('/open/wechat/miniProgram/weChatCodeUrl', {
        data: {
            checkPath: false,
            ...version,
            ...data
        }
    })
}

// 查询供应商商品列表查询分享数量
/**
 * 查询供应商商品列表
 */
export function goodsCount(data: QueryInviteSpuCountVo): API.Res<SpuCountVo> {
    return goodsRequest.post('/buyer/supplier/goods/count', { data })
}

// 查询供应商商品列表查询分享数量
/**
 * 查询供应商商品列表
 */
export function openGoodsCount(data: QueryInviteSpuCountVo): API.Res<SpuCountVo> {
    return openGoodsRequest.post('/open/supplier/goods/count', { data })
}

// 供应商推广分享的商品数量统计
/**
 * 供应商推广分享的商品数量统计
 */
export function goodsInviteCount(data: QueryInviteSpuCountVo): API.Res<InviteDisSpuCountVo> {
    return goodsRequest.post('/mall/goods/invite/count', { data })
}

// 供应商推广分享的商品数量统计
/**
 * 供应商推广分享的商品数量统计
 */
export function openGoodsInviteCount(data: QueryInviteSpuCountVo): API.Res<InviteDisSpuCountVo> {
    return openGoodsRequest.post('/open/mall/goods/invite/count', { data })
}

// 修改当前公司联系人二维码信息
/**
 * 修改当前公司联系人二维码信息
 */
export function editContactQr(data: EditQrCodeUrlVo): API.Res<object> {
    return drpRequest.post('/supplierInfo/editContactQr', { data })
}

// 获取当前公司联系人二维码信息
/**
 * 获取当前公司联系人二维码信息
 */
export function queryContactQr(): API.Res<string> {
    return drpRequest.get('/supplierInfo/queryContactQr')
}

// 查询推广类型
/**
 * 查询推广信息
 */
export function queryPromoteInfo(params: QueryPromoteInfoUsingGet1Params): API.Res<PromoteInfoVo> {
    return openGoodsRequest.get('/open/mall/goods/invite/queryPromoteInfo', { params })
}
